"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = { name: "circle", x: "cx", y: "cy", size: "r" };
exports.Ellipse = { name: "ellipse", x: "cx", y: "cy", width: "rx", height: "ry" };
exports.Rectangle = { name: "rect", x: "x", y: "y", width: "width", height: "height" };
var Position;
(function (Position) {
    Position[Position["Start"] = 0] = "Start";
    Position[Position["Center"] = 1] = "Center";
    Position[Position["End"] = 2] = "End"; //end of the element is at the value, e.g. right or top
})(Position = exports.Position || (exports.Position = {}));



//////////////////
// WEBPACK FOOTER
// ./~/music-visualization/lib/types.js
// module id = 133
// module chunks = 3